import { FC } from 'react';

import CreditCardAdd from 'components/credit-card-add';
import { CREDIT_CARD_SAVE } from 'utils/constants';

const CreditCardMethod: FC = (): JSX.Element => <CreditCardAdd intent={CREDIT_CARD_SAVE} />;

export default CreditCardMethod;
